import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { useLanguage } from '../pages/LanguageContext'; // <-- Add this

function Footer() {
  const { language } = useLanguage();

  // Labels in both languages
  const labels = {
    services: { en: 'Services', ar: 'الخدمات' },
    technology: { en: 'Technology', ar: 'التقنيات' },
    info: { en: 'Info', ar: 'معلومات' },
    smartHome: { en: 'Smart Home Setup & Automation', ar: 'تركيب أنظمة المنزل الذكي' },
    smartSecurity: { en: 'System Support & Maintenance', ar: 'تحسين الشبكة والأمان' },
    smartClimate: { en: 'Network & Security Optimization', ar: 'الدعم والصيانة الذكية' },
    matter: { en: 'Matter', ar: 'ماتر' },
    zigbee: { en: 'Zigbee', ar: 'زيجبي' },
    wifi: { en: 'Wi-Fi', ar: 'واي فاي' },
    aboutUs: { en: 'Our Story', ar: 'قصتنا' },
    careers: { en: 'Careers', ar: 'الوظائف' },
    contactUs: { en: 'Contact Us', ar: 'اتصل بنا' },
    allRights: { en: 'All rights reserved.', ar: 'جميع الحقوق محفوظة.' }
  };

  // Use ONLY system/simple font for Arabic
  const arabicFont = "Tahoma, Arial, sans-serif";

  return (
    <footer
      style={{
        ...styles.footer,
        direction: language === 'ar' ? 'rtl' : 'ltr',
        fontFamily: language === 'ar'
          ? arabicFont
          : styles.footer.fontFamily,
      }}
    >
      <div style={{
        ...styles.footerTop,
        textAlign: language === 'ar' ? 'right' : 'left',
      }}>
        <div style={styles.column}>
          <h4 style={{
            ...styles.heading,
            fontFamily: language === 'ar' ? arabicFont : styles.heading.fontFamily
          }}>{labels.services[language]}</h4>
          <p style={styles.text}>
            <Link to="/SmartHomeAutomationPage" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>
              {labels.smartHome[language]}
            </Link>
          </p>
          <p style={styles.text}>
            <Link to="/services/home-security" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>
              {labels.smartSecurity[language]}
            </Link>
          </p>
          <p style={styles.text}>
            <Link to="/services/industrial-application" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>
              {labels.smartClimate[language]}
            </Link>
          </p>
        </div>

        <div style={styles.column}>
          <h4 style={{
            ...styles.heading,
            fontFamily: language === 'ar' ? arabicFont : styles.heading.fontFamily
          }}>{labels.technology[language]}</h4>
          <p style={styles.text}>
            <Link to="/technology/matter" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>{labels.matter[language]}</Link>
          </p>
          <p style={styles.text}>
            <Link to="/technology/zigbee" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>{labels.zigbee[language]}</Link>
          </p>
          <p style={styles.text}>
            <Link to="/technology/wifi" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>{labels.wifi[language]}</Link>
          </p>
        </div>

        <div style={styles.column}>
          <h4 style={{
            ...styles.heading,
            fontFamily: language === 'ar' ? arabicFont : styles.heading.fontFamily
          }}>{labels.info[language]}</h4>
          <p style={styles.text}>
            <Link to="/AboutUsPage" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>{labels.aboutUs[language]}</Link>
          </p>
          <p style={styles.text}>
            <Link to="/CareerPage" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>{labels.careers[language]}</Link>
          </p>
          <p style={styles.text}>
            <Link to="/contact" style={{...styles.whiteLink, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>{labels.contactUs[language]}</Link>
          </p>
        </div>
      </div>

      <div style={styles.footerBottom}>
        <div style={styles.socialIcons}>
          <a
            href="https://www.facebook.com/we.mass1/"
            target="_blank"
            rel="noreferrer"
            style={styles.socialIcon}
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.instagram.com/we.mass/"
            target="_blank"
            rel="noreferrer"
            style={styles.socialIcon}
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://jo.linkedin.com/company/mass-smartsolutions"
            target="_blank"
            rel="noreferrer"
            style={styles.socialIcon}
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
        </div>
        <p style={{...styles.copy, fontFamily: language === 'ar' ? arabicFont : 'inherit'}}>
          &copy; {new Date().getFullYear()} Mass Smart Solution. {labels.allRights[language]}
        </p>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: '#111',
    padding: '4rem 2rem 2rem',
    borderTop: '1px solid #222',
    fontSize: '0.95rem',
    color: '#fff',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  footerTop: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '2rem',
    marginBottom: '3rem',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  heading: {
    fontWeight: 'bold',
    marginBottom: '1rem',
    fontSize: '1.2rem',
    color: '#fff',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  text: {
    color: '#ccc',
  },
  partnerButton: {
    marginTop: '1rem',
    padding: '0.75rem 1rem',
    backgroundColor: '#1a4bb7',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontWeight: '600',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    transition: 'background-color 0.3s ease',
  },
  footerBottom: {
    textAlign: 'center',
    borderTop: '1px solid #333',
    paddingTop: '1.5rem',
    fontSize: '0.85rem',
    color: '#aaa',
  },
  socialIcons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1.5rem',
    fontSize: '1.5rem',
    marginBottom: '1rem',
  },
  socialIcon: {
    color: '#fff',
    transition: 'transform 0.3s ease, color 0.3s ease',
    textDecoration: 'none',
  },
  copy: {
    marginBottom: '0.3rem',
    color: '#ccc',
  },
  link: {
    textDecoration: 'none',
    color: '#ccc',
    fontWeight: '500',
    transition: 'color 0.3s ease',
    cursor: 'pointer',
  },
  whiteLink: {
    color: '#ccc',
  },
};

export default Footer;
